var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"loading-indicator"},[_vm._v("lädt")]):_vm._e(),_c('div',{class:{ 'hidden': _vm.isLoading }},[_c('my-header'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }